import { render, staticRenderFns } from "./newAlbum.vue?vue&type=template&id=12989328&scoped=true&"
import script from "./newAlbum.vue?vue&type=script&lang=js&"
export * from "./newAlbum.vue?vue&type=script&lang=js&"
import style0 from "./newAlbum.vue?vue&type=style&index=0&id=12989328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12989328",
  null
  
)

export default component.exports